import './Printables.css';
import React from "react";


function Printables() {
    return (
        <div className="landing">
            <p className="printablesHeaderText"> printables </p>
            <div className="landingExpandingBlurCircle"> </div>
            <p className="printablesSectionHeader"> morning printables </p>
            <p className="printablesSectionHeader"> evening printables </p>
        </div>
    )
}

export default Printables;